import { useCallback } from "react";
import {
  createSearchParams,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import Drawer from "@mui/material/Drawer";

import { useGetRenewal } from "@hooks/renewals/useGetRenewal";
import { useAccessPattern } from "@hooks/useAccessPattern";
import { useGlobalLoading } from "@hooks/common";
import { LoadingOverlay } from "@covertree/ui";

import { RenewalDetailsContent } from "./RenewalDetailsContent";

export function RenewalDetails() {
  const { renewalLocator } = useParams();
  const { canMarkRenewalAsPaid } = useAccessPattern();

  const { data, loading, error } = useGetRenewal(
    renewalLocator,
    canMarkRenewalAsPaid
  );
  const { loading: globalLoading } = useGlobalLoading();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const onClose = useCallback(() => {
    navigate({
      pathname: "../",
      search: createSearchParams(searchParams).toString(),
    });
  }, [searchParams]);

  return (
    <Drawer
      anchor="right"
      open={true}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: {
            sm: "65%",
            md: "80%",
            lg: "71%",
          },
          maxWidth: "960px",
          minWidth: "350px",
        },
      }}>
      <RenewalDetailsContent
        onClose={onClose}
        renewal={data?.getRenewal}
        loading={loading}
        error={!!error}
      />
      {globalLoading && <LoadingOverlay />}
    </Drawer>
  );
}
